interface AudioManagerOptions {
  successUrl?: string;
  failUrl?: string;
  successVolume?: number;
  failVolume?: number;
  enabled?: boolean;
}

export class AudioManager {
  private successAudio: HTMLAudioElement | null;
  private failAudio: HTMLAudioElement | null;
  private enabled: boolean;
  private successVolume: number;
  private failVolume: number;

  constructor(options: AudioManagerOptions = {}) {
    this.successAudio = options.successUrl
      ? new Audio(options.successUrl)
      : null;
    this.failAudio = options.failUrl ? new Audio(options.failUrl) : null;
    this.enabled = options.enabled ?? true;
    this.successVolume = options.successVolume ?? 1;
    this.failVolume = options.failVolume ?? 1;
    if (this.successAudio) {
      this.successAudio.preload = "auto";
    }
    if (this.failAudio) {
      this.failAudio.preload = "auto";
    }
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled;
  }

  playSuccess(): void {
    this.play(this.successAudio, this.successVolume);
  }

  playFail(): void {
    this.play(this.failAudio, this.failVolume);
  }

  private play(audio: HTMLAudioElement | null, volume: number): void {
    if (!this.enabled || !audio) {
      return;
    }
    audio.volume = Math.max(0, Math.min(1, volume));
    audio.currentTime = 0;
    void audio.play().catch(() => undefined);
  }
}
